module.exports = __webpack_public_path__ + "img/11.bcb3306a.png";